import React from "react";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ColorLogo from "../partials/images/icon/oryzalogo_colour.png";
import "../partials/main.min.css";
import "../partials/bootstrap.min.css";
import "../partials/style.css";



export default function header() {
    return (
      <>
        {/* <div classNameName="header__content2">
          <div classNameName="head-rapper">
            <div classNameName="header__content-right2"></div>
            <div classNameName="header-logo">
              <a href="/oryza/aboutus">
                <img src={Logo} alt="Oryza" classNameName="logo" />
              </a>
            </div>
            <div classNameName="header__content-right3">
              <span classNameName="header-contact sidebar_set">
                <a
                  classNameName="tel"
                  href="tel:+94767008800"
                  target="_blank"
                  style={{ color: "#fff" }}
                >
                  Call us : + 94 76 700 8800
                </a>
              </span>
              <div classNameName="header-social">
                <ul classNameName="sidebar_set list-social list-social--light">
                  <li classNameName="list-social__item">
                    <a
                      classNameName="ic-fb"
                      href="https://www.facebook.com/oryzaleisure/"
                      target="_blank"
                    >
                      <i classNameName="zmdi zmdi-facebook"></i>
                    </a>
                  </li>
                  <li classNameName="list-social__item">
                    <a
                      classNameName="ic-insta"
                      href="https://www.instagram.com/oryzaleisure/"
                      target="_blank"
                    >
                      <i classNameName="zmdi zmdi-instagram"></i>
                    </a>
                  </li>
                  <li
                    classNameName="list-social__item"
                    style={{ paddingRht: "10px" }}
                  >
                    <a
                      classNameName="ic-whatsapp"
                      href="https://wa.me/94767008800"
                      target="_blank"
                    >
                      <i classNameName="zmdi zmdi-whatsapp"></i>
                    </a>
                  </li>
                </ul>
              </div>
              <button
                classNameName="hamburger hamburger--slider float-right hamburger--sm js-menusb-btn"
                type="button"
              >
                <span classNameName="hamburger-box">
                  <span classNameName="hamburger-inner"></span>
                </span>
              </button>
            </div>
          </div>
        </div> */}
        <div className="header header-1 d-none d-lg-block js-header-1 headcolor">
          <div className="header__bar">
            <div className="wrap wrap--w1790">
              <div className="container-fluid2">
                <div className="header__content">
                  <div className="logo">
                    <a href="/oryza">
                      <img
                        src={ColorLogo}
                        alt="Oryza Leisure"
                        style={{
                          maxHeight: "80px",
                          paddingTop: "15px",
                          paddingLeft: "15px",
                        }}
                      />
                    </a>
                  </div>
                  <div className="header__content-right">
                    <nav className="header-nav-menu">
                      <ul className="menu nav-menu">
                        <li className="menu-item menu-item-has-children">
                          <a href="/oryza">Destinations</a>
                        </li>
                        <li className="menu-item">
                          <a href="/oryza">Oryza Leisure</a>
                        </li>
                        <li className="menu-item">
                          <a href="/oryza">Offers</a>
                        </li>
                        <li className="menu-item">
                          <a href="/oryza-countactus">Contact Us</a>
                        </li>
                      </ul>
                    </nav>
                    <div className="header-social">
                      <ul
                        className="list-social"
                        style={{ display: "flex", gap: "0" }}
                      >
                        <li className="list-social__item">
                          <a
                            href="https://www.facebook.com/oryzaleisure/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Facebook"
                            style={{ color: "#000" }}
                          >
                            <FacebookIcon fontSize="medium" />
                          </a>
                        </li>
                        <li className="list-social__item">
                          <a
                            href="https://www.instagram.com/oryzaleisure/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="Instagram"
                            style={{ color: "#000" }}
                          >
                            <InstagramIcon fontSize="medium" />
                          </a>
                        </li>
                        <li className="list-social__item">
                          <a
                            href="https://wa.me/94767008800"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="WhatsApp"
                            style={{ color: "#000" }}
                          >
                            <WhatsAppIcon fontSize="medium" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="header-mobile d-block d-lg-none headcolor">
          <div className="header-mobile__bar">
            <div className="container-fluid">
              <div className="header-mobile__bar-inner">
                <a className="logo" href="/oryza">
                  <img
                    src={ColorLogo}
                    alt="Oryza Leisure"
                    style={{
                      maxHeight: "100px",
                      paddingTop: "15px",
                      paddingLeft: "15px",
                    }}
                  />
                </a>
                <IconButton
                  edge="end"
                  color="inherit"
                  aria-label="menu"
                  sx={{ float: "right" }}
                  // onClick={handleMenuClick}
                >
                  <MenuIcon />
                </IconButton>
              </div>
            </div>
          </div>
          <nav className="header-nav-menu-mobile">
            <div className="container-fluid">
              <ul className="menu nav-menu menu-mobile">
                <li className="menu-item">
                  <a href="/oryza">ORZYA LEISURE</a>
                </li>
                <li className="menu-item menu-item-has-children">
                  <a
                    href="/oryza"
                    data-toggle="collapse"
                    data-target="#sub1"
                    aria-expanded="true"
                    aria-controls="sub1"
                  >
                    DESTINATIONS
                  </a>
                  <ul
                    className="sub-menu collapse"
                    id="sub1"
                    data-parent="#nav-menu-sidebar"
                  >
                    <li className="menu-item">
                      <a href="https://pettipettimirissa.com">
                        PETTI PETTI MIRISSA
                      </a>
                    </li>
                    <li className="menu-item">
                      <a href="https://kentcottagenuwaraeliya.com">
                        KENT COTTAGE NUWARA ELIYA
                      </a>
                    </li>
                    <li className="menu-item">
                      <a href="https://bananabunkskandy.com">
                        BANANA BUNKS KANDY
                      </a>
                    </li>
                    <li className="menu-item">
                      <a href="https://bananabunksmirissa.com">
                        BANANA BUNKS MIRISSA
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="menu-item">
                  <a href="/oryza/offers">OFFERS</a>
                </li>

                <li className="menu-item">
                  <a href="/oryza/contact">CONTACT US</a>
                </li>
              </ul>
            </div>
          </nav>
        </div>
      </>
    );
}
